'use strict';
angular.module('weixinPreviewHistoryModule', [
    'weixinPreviewHistoryRouterModule',
])
    .controller('weixinPreviewHistoryCtrl', ['$scope', 'trsHttpService', '$state', 'wechatBtnService', 'modalDialog', '$stateParams', 'editcenterRightsService', 'trsspliceString', '$q', function($scope, trsHttpService, $state, wechatBtnService, modalDialog, $stateParams, editcenterRightsService, trsspliceString, $q) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 10,
            };
            $scope.status = {
                copyCurrPage: 1,
                zbBtns: true,
            };
            $scope.data = {
                selectedArray: [],
            };
        }

        /**
         * [initData description]初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            // requestData();
            initBtnRights();
            getChannelType();
        }

        /**
         * [selectAll description]全选
         * @return {[type]} [description]
         */
        $scope.selectAll = function() {
            $scope.data.selectedArray = $scope.data.selectedArray.length == $scope.data.items.length ? [] : [].concat($scope.data.items);
        };

        /**
         * [selectDoc description]单选
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.selectDoc = function(item) {
            var index = $scope.data.selectedArray.indexOf(item);
            if (index < 0) {
                $scope.data.selectedArray.push(item);
            } else {
                $scope.data.selectedArray.splice(index, 1);
            }
        };

        /**
         * [requestData description]列表
         * @return {[type]} [description]
         */
        $scope.requestData = function() {
            requestData();
        };

        /**
         * [findDocDetails description]获取稿件详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.findDocDetails = function(item) {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'findDocDetails',
                DocIds: item.SENDINGORDER,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {

            });
            wechatBtnService.foregoingPreview(item, 'preview', 'detail');
        };

        /**
         * [requestData description]列表刷新
         * @return {[type]} [description]
         */
        function requestData() {
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'queryPreviewCardMessages',
                Channelid: $stateParams.wxchannelid,
                OperTimeStart: $scope.status.fromdate,
                OperTimeEnd: $scope.status.untildate,
                CurrPage: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
            };
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                var ListItems = data.DATA;
                $scope.data.items = ListItems;
                $scope.data.selectedArray = [];
                $scope.page = data.PAGER;
                // getMassSendFalgs(ListItems);
            });
        }

        /**
         * [pageChanged description]获取状态类型
         *  @param  {[type]} item [description]
         * @return {[type]} [description]
         */
        $scope.getStatus = function(item) {
            switch (item) {
                case '1':
                    return '发布成功';
                case '2':
                    return '未发布';
                case '0':
                    return '发布失败';
                case '3':
                    return '取消发布';
            }

        };

        /**
         * [selectPageNum description]选择分页条数
         * @return {[type]} [description]
         */
        $scope.selectPageNum = function() {
            $scope.status.copyCurrPage = 1;
            requestData();
        };

        /**
         * [pageChanged description]跳转到下一页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [jumpToPage description]跳转到指定页
         * @return {[type]} [description]
         */
        $scope.jumpToPage = function() {
            if ($scope.status.copyCurrPage > $scope.page.PAGECOUNT) {
                $scope.status.copyCurrPage = $scope.page.PAGECOUNT;
            }
            $scope.page.CURRPAGE = $scope.status.copyCurrPage;
            requestData();
        };

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeixinListBtn('wechat.yizuban', $stateParams.wxchannelid).then(function(rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [getChannelType description] 查询公众号类型
         * @return {[type]} [description]
         */
        function getChannelType() {
            var defer = $q.defer();
            var params = {
                serviceid: 'mlf_wechatgroupsend',
                methodname: 'getChannelType',
                ChannelIds: $state.params.wxchannelid,
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                $scope.status.theChannelType = data[$state.params.wxchannelid];
                defer.resolve();
            });
            return defer.promise;
        }

        /**
         * [groupSendMessage description] 群发消息按钮hover提示
         * @return {[type]} [description]
         */
        $scope.groupSendMessage = function() {
            if ($scope.status.theChannelType === '订阅号' || $scope.status.theChannelType === '服务号') {
                return '未认证公众号不能群发';
            }
            if ($scope.status.theChannelType === '认证服务号') {
                return '每月最多4次';
            }
            if ($scope.status.theChannelType === '认证订阅号') {
                return '每日最多一次';
            }
        };

        /**
         * [groupSendMessageDisabled description] 群发按钮是否禁用
         * @return {[type]} [description]
         */
        $scope.groupSendMessageDisabled = function() {
            if ($scope.status.theChannelType === '订阅号' || $scope.status.theChannelType === '服务号') {
                return true;
            }
            if ($scope.status.theChannelType === '认证服务号') {
                return 'showTips';
            }
            if ($scope.status.theChannelType === '认证订阅号') {
                return 'showTips';
            }
        };

        /**
         * [getMassSendFalgs description] 获取是否群发
         *  @param  {[type]} ListItems [description]
         * @return {[type]} [description]
         */
        // function getMassSendFalgs(ListItems) {
        //     var defer = $q.defer();
        //     var docIds = trsspliceString.spliceString(ListItems, 'METADATAIDS', ',');
        //     var params = {
        //         serviceid: 'mlf_wechatgroupsend',
        //         methodname: 'isDocGroupSend',
        //         DocIds: docIds,
        //     };
        //     trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
        //         angular.forEach(ListItems, function(value, key) {
        //             jQuery.each(data, function(i, val) {
        //                 if (value.METADATAID == i) {
        //                     ListItems[key].massSendFalg = val;
        //                 }
        //             });
        //         });
        //         defer.resolve(ListItems);
        //     });
        //     return defer.promise;
        // }

    }]);
